import { render, staticRenderFns } from "./CollectionNavigator.vue?vue&type=template&id=61565704&scoped=true&"
import script from "./CollectionNavigator.vue?vue&type=script&lang=js&"
export * from "./CollectionNavigator.vue?vue&type=script&lang=js&"
import style0 from "./CollectionNavigator.vue?vue&type=style&index=0&id=61565704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61565704",
  null
  
)

export default component.exports